import { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

const WorkingExperienceLayout = () => {
  const [currentDate, setCurrentDate] = useState(()=>{
    let today = new Date();
    let date = today.toLocaleDateString("en-GB", { // you can use undefined as first argument
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });;
    // let date = today.getDate() +'-'+ (today.getMonth()+1) +'-'+ today.getFullYear();
    return date;
  })
  // useEffect(()=>{
    
  // },[])


    return <>
    <div className="WorkingExperienceLayout-wrapper">
    {/* <h1>My Working Experience Timeline</h1> */}
<div className="timeline" id="my_element">
  
<OverlayTrigger
    placement="top"
    delay={{ show: 250, hide: 400 }}
    overlay={<Tooltip id="button-tooltip">
    {currentDate}
  </Tooltip>}
  >
    <h2 className=" timeline__item timeline__item--year ">Current</h2>
  </OverlayTrigger>,
  
  <div className="timeline__item">
    <h3 className="timeline__title">Softwere Engineer</h3>
    <h4 className="timeline__title timeline-company">Ultra-X BD</h4>
    <p className="timeline__blurb">A branch of Ultra-X Asia Pacific Inc. [Japan]
    <br/>
    Duration: 1+ year (05-January-2021 to Present)
    </p>
   
    {/* <p className="timeline__blurb"> */}
    <ul className="timeline__blurb">
        <li>Working mainly as a Reactjs and Nextjs Developer.</li>
        <li>Working in a MERN stack.</li>
        <li>Worked in several big projects successfully with latest tech.</li>
        <li>Previously worked with php with smarty engine.</li>
        <li>Previously worked with C++ for making libraries.</li>
    </ul>
    {/* </p> */}
    
  
  </div>
  <OverlayTrigger
    placement="top"
    delay={{ show: 250, hide: 400 }}
    overlay={<Tooltip id="button-tooltip">
    05-January-2021
  </Tooltip>}
  >
    <h2 className=" timeline__item timeline__item--year ">05-January-2021</h2>
  </OverlayTrigger>
  
  
      <div className="timeline__item">
      
        <h3 className="timeline__title">Lecturer</h3>
       
        <h4 className="timeline__title timeline-company">University of Global Village, Barisal.</h4>
        <p className="timeline__blurb">
        Duration: 1 year. (08-January-2020 to 01-January-2021)
        </p>
        <ul className="timeline__blurb">
            <li>Worked as a fulltime lecturer.</li>
            <li>Took major courses like Structural Programming, OOP, Data structure, Algorithm etc.</li>
            <li>Organized some important seminar.</li>
            <li>Prepared course material and evaluate exam papers.</li>
            <li>Relevant departmental tasks.</li>
        </ul>
      </div>
  
  <OverlayTrigger
    placement="top"
    delay={{ show: 250, hide: 400 }}
    overlay={<Tooltip id="button-tooltip">
    01-January-2020
  </Tooltip>}
  >
    <h2 className=" timeline__item timeline__item--year ">01-January-2020</h2>
  </OverlayTrigger>,
  
  <div className="timeline__item">
    <h3 className="timeline__title">Graduate Teaching Assistant</h3>
    <h4 className="timeline__title timeline-company">East West University, Dhaka.</h4>
    <p className="timeline__blurb">
    Duration: 5 months. (01/August/2019 - 01/January/2020)
    </p>
   
    
    <ul className="timeline__blurb">

        <li>Helped course instructor preparing course materials.</li>
        <li>Helped course instructor with lab classess.</li>
        <li>Took extra problem solving classes</li>
        <li>Appointed course: Structural Programming, OOP, Algorithm.</li>
        <li>Relevant tasks.</li>
    </ul>
    
    
  
  </div>
  
  <OverlayTrigger
    placement="top"
    delay={{ show: 250, hide: 400 }}
    overlay={<Tooltip id="button-tooltip">
    01-August-2019
  </Tooltip>}
  >
    <h2 className=" timeline__item timeline__item--year ">01-August-2019</h2>
  </OverlayTrigger>
  
  
  <div className="timeline__item">
    <h3 className="timeline__title">Undergraduate Teaching Assistant</h3>
    <h4 className="timeline__title timeline-company">East West University, Dhaka.</h4>
    <p className="timeline__blurb">
    Duration: 2 years. (01/August/2017 - 31/July/2019)
    </p>
   
    
    <ul className="timeline__blurb">

        <li>Helped course instructor with lab classess.</li>
        <li>Took extra problem solving classes</li>
        <li>Appointed course: Structural Programming, OOP, AI, Machine Learning.</li>
        <li>Relevant tasks.</li>
    </ul>
  </div>
  
  <OverlayTrigger
    placement="top"
    delay={{ show: 250, hide: 400 }}
    overlay={<Tooltip id="button-tooltip">
    01-August-2017
  </Tooltip>}
  >
    <h2 className=" timeline__item timeline__item--year ">01-August-2017</h2>
  </OverlayTrigger>
  
  <div className="timeline__item">
    <h3 className="timeline__title" style={{textAlign: 'center'}}>Jobless and Poor.</h3>
    {/* <h4 className="timeline__title timeline-company">East West University, Dhaka.</h4>
    <p className="timeline__blurb">
    Duration: 2 years. (01/August/2017 - 31/July/2019)
    </p>
   
    <p className="timeline__blurb">
    <ul>
        <li>Helped course instructor with lab classess.</li>
        <li>Took extra problem solving classes</li>
        <li>Appointed course: Structural Programming, OOP, AI, Machine Learning.</li>
        <li>Relevant tasks.</li>
    </ul>
    </p> */}
  </div>
  <OverlayTrigger
    placement="top"
    delay={{ show: 250, hide: 400 }}
    overlay={<Tooltip id="button-tooltip">
    12-Octobor-1996
  </Tooltip>}
  >
    <h2 className=" timeline__item timeline__item--year " >BORN</h2>
  </OverlayTrigger>
  
  
</div>

        </div>

        </>
}

export default WorkingExperienceLayout;